import styled from 'styled-components'

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 4px 16px 4px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    margin: 0 0 24px 0;
  }
`

export const Title = styled.h1`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin: 0;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    font-size: 24px;
  }
`
